module.exports = __webpack_public_path__ + "img/Busy_Corner@2x.e5bedab0.png";